import { currencyServices } from 'src/services/reservation/currency/currency.service'
import { productServices } from 'src/services/reservation/product/product.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { bannerServices } from 'src/services/reservation/banner/Banner.service'
import { landingServices } from 'src/services/reservation/landing/Landing.service'
import { emailServices } from 'src/services/notification/email/email.service'

export const getInverseIndex = (index, fields) => {
  const currencyIndex = fields.findIndex(
    (currency) =>
      currency.currency_id === fields[index]?.currency_to_id &&
      currency.currency_to_id === fields[index]?.currency_id
  )
  if (currencyIndex === index) return -1
  return currencyIndex
}

export const removeCurrenciesByIds = (index, fields, remove, editMode, isWorkUnit = false) => {
  const currency = fields[index]
  if (editMode && currency && !('new_register' in currency)) {
    if (isWorkUnit) {
      currencyServices.deleteCurrencyByWorkUnit(currency)
    } else {
      currencyServices.deleteCurrencyByBusinessUnit(currency)
    }
  }
  remove(index)
}

export const removeProductsByIds = async (
  index,
  fields,
  remove,
  editMode,
  refresh,
  notify,
  isWorkUnit = false
) => {
  try {
    const product = fields[index]
    if (editMode && product && !('new_register' in product)) {
      if (isWorkUnit) {
        await productServices.deleteProductByWorkUnit(product)
      } else {
        await productServices.deleteProductByWorkUnitByBusinessUnit(product)
      }
    }
    remove(index)
    customAwait([refresh])
  } catch (error) {
    const messaggeKey = error?.response?.data?.detail
    if (messaggeKey) {
      notify(`${messaggeKey}`, {
        type: 'error',
      })
    } else {
      notify(`ra.notification.deleted_error_masculine`, {
        type: 'error',
        messageArgs: { element: 'producto' },
      })
    }
  }
}

export const removeBannersByIds = async (
  index,
  fields,
  remove,
  editMode,
  notify,
  isWorkUnit = false
) => {
  try {
    const banner = fields[index]
    if (editMode && banner && !('new_register' in banner)) {
      if (isWorkUnit) {
        await bannerServices.deleteBannerByWorkUnit(banner)
      } else {
        await bannerServices.deleteBannerByBusinessUnit(banner)
      }
    }
    remove(index)
  } catch (error) {
    const messaggeKey = error?.response?.data?.detail
    if (messaggeKey) {
      notify(`${messaggeKey}`, {
        type: 'error',
      })
    } else {
      notify(`ra.notification.deleted_error_masculine`, {
        type: 'error',
        messageArgs: { element: 'banner' },
      })
    }
  }
}

export const removeLandingsByIds = async (
  index,
  fields,
  remove,
  editMode,
  notify,
  isWorkUnit = false
) => {
  try {
    const landing = fields[index]
    if (editMode && landing && !('new_register' in landing)) {
      if (isWorkUnit) {
        await landingServices.deleteLandingByWorkUnit(landing)
      } else {
        await landingServices.deleteLandingByBusinessUnit(landing)
      }
    }
    remove(index)
  } catch (error) {
    const messaggeKey = error?.response?.data?.detail
    if (messaggeKey) {
      notify(`${messaggeKey}`, {
        type: 'error',
      })
    } else {
      notify(`ra.notification.deleted_error_masculine`, {
        type: 'error',
        messageArgs: { element: 'landing' },
      })
    }
  }
}

export const removeSectorByIds = async (
  index,
  fields,
  remove,
  editMode,
  notify
) => {
  try {
    const sector = fields[index]
    if (editMode && sector && !('new_register' in sector)) {
      await landingServices.deleteSectorByLanding(sector.id)
      notify(`ra.notification.deleted_success_masculine`, {
        type: 'success',
        messageArgs: { element: 'sector' },
      })
    }
    remove(index)
  } catch (error) {
    const messaggeKey = error?.response?.data?.detail
    if (messaggeKey) {
      notify(`${messaggeKey}`, {
        type: 'error',
      })
    } else {
      notify(`ra.notification.deleted_error_masculine`, {
        type: 'error',
        messageArgs: { element: 'sector' },
      })
    }
  }
}

export const removeBannerBySectorByIds = async (
  banner,
  remove,
  editMode,
  notify
) => {
  try {
    if (editMode && banner && !('new_register' in banner)) {
      await landingServices.deleteBannerBySector(banner)
      notify(`ra.notification.deleted_success_masculine`, {
        type: 'success',
        messageArgs: { element: 'banner' },
      })
    }
    remove()
  } catch (error) {
    const messaggeKey = error?.response?.data?.detail
    if (messaggeKey) {
      notify(`${messaggeKey}`, {
        type: 'error',
      })
    } else {
      notify(`ra.notification.deleted_error_masculine`, {
        type: 'error',
        messageArgs: { element: 'banner' },
      })
    }
  }
}


export const removeEmailsByIds = async (
  index,
  fields,
  remove,
  refresh,
  notify,
  setOpenModal
) => {
  try {
    const email = fields[index]
    if (email && !('new_register' in email)) {
      await emailServices.deleteEmail(email?.id)
    }
    remove(index)
  } catch (error) {
    console.log("error", error);
    const messaggeKey = error?.response?.data?.detail
    if (messaggeKey) {
      notify(`${messaggeKey}`, {
        type: 'error',
      })
    } else {
      notify(`ra.notification.deleted_error_masculine`, {
        type: 'error',
        messageArgs: { element: 'email' },
      })
    }
  } finally {
    setOpenModal(false)
    customAwait([refresh])
  }
}